module.exports = __webpack_public_path__ + "media/oishiine.0eed65a0.mp3";